import { Breakpoints } from '../../../../types/Breakpoints';

/* eslint-disable camelcase */
/**
 * Creates all possible image urls with width.
 *  -> <source srcset="..." />.
 *
 * All values are generated in the backend,
 * to create a new srcset item its not enough to add it here.
 * Needs to be added in backend as well.
 *
 */
const IMAGE = {
  width_320: Breakpoints.s_smartphone_portrait,
  width_640: Breakpoints.m_smartphone_landscape,
  width_1024: Breakpoints.s_tablet_landscape,
  width_1280: Breakpoints.m_screen,
  width_1600: Breakpoints.xl_screen,
};

/**
 * Breakpoint mapping for readability.
 */
const BREAKPOINT = {
  max_320: Breakpoints.s_smartphone_portrait,
  max_480: Breakpoints.s_smartphone_landscape,
  max_640: Breakpoints.m_smartphone_landscape,
  max_768: Breakpoints.s_tablet_portrait,
  max_1024: Breakpoints.s_tablet_landscape,
  max_1152: Breakpoints.s_screen,
  max_1280: Breakpoints.m_screen,
  max_1440: Breakpoints.l_screen,
  max_1600: Breakpoints.xl_screen,
} as const;

const RESPONSIVE_TYPE = {
  topHeadlineImage: 'topHeadlineImage',
  topHeadlineImageSmall: 'topHeadlineImageSmall',
  teaser: 'teaser',
  teaserBlog: 'teaserBlog',
  teaserBlogTop: 'teaserBlogTop',
  userProfile: 'userProfile',
  contentImage: 'contentImage',
  imageGalleryImage: 'imageGalleryImage',
  imageGalleryImageInPopUp: 'imageGalleryImageInPopUp',
} as const;

/**
 * Creates sizes for breakpoints.
 * -> <source sizes=""
 */
const BREAKPOINT_TO_IMAGE_WIDTH = [
  {
    type: RESPONSIVE_TYPE.topHeadlineImage,
    values: [
      // AT BREAKPOINT 320 TAKE IMAGE WITH WIDTH 320
      [BREAKPOINT.max_320, IMAGE.width_320],
      [BREAKPOINT.max_640, IMAGE.width_640],
      [BREAKPOINT.max_768, IMAGE.width_1024],
      [BREAKPOINT.max_1024, IMAGE.width_640],
      [BREAKPOINT.max_1280, IMAGE.width_640],
      [BREAKPOINT.max_1440, IMAGE.width_1024],
      [BREAKPOINT.max_1600, IMAGE.width_640],
    ],
  },
  {
    type: RESPONSIVE_TYPE.topHeadlineImageSmall,
    values: [[BREAKPOINT.max_320, IMAGE.width_320]],
  },
  {
    type: RESPONSIVE_TYPE.teaser,
    values: [
      [BREAKPOINT.max_320, IMAGE.width_320],
      [BREAKPOINT.max_640, IMAGE.width_640],
      [BREAKPOINT.max_768, IMAGE.width_1024],
      [BREAKPOINT.max_1024, IMAGE.width_640],
      [BREAKPOINT.max_1280, IMAGE.width_640],
      [BREAKPOINT.max_1440, IMAGE.width_1024],
      [BREAKPOINT.max_1600, IMAGE.width_640],
    ],
  },
  {
    type: RESPONSIVE_TYPE.teaserBlog,
    values: [
      [BREAKPOINT.max_320, IMAGE.width_320],
      [BREAKPOINT.max_640, IMAGE.width_640],
      [BREAKPOINT.max_1024, IMAGE.width_320],
      [BREAKPOINT.max_1280, IMAGE.width_320],
      [BREAKPOINT.max_1600, IMAGE.width_320],
    ],
  },
  {
    type: RESPONSIVE_TYPE.teaserBlogTop,
    values: [
      [BREAKPOINT.max_320, IMAGE.width_320],
      [BREAKPOINT.max_640, IMAGE.width_640],
      [BREAKPOINT.max_1024, IMAGE.width_320],
      [BREAKPOINT.max_1280, IMAGE.width_640],
      [BREAKPOINT.max_1600, IMAGE.width_640],
    ],
  },
  {
    type: RESPONSIVE_TYPE.userProfile,
    values: [
      [BREAKPOINT.max_320, IMAGE.width_320],
      [BREAKPOINT.max_640, IMAGE.width_640],
      [BREAKPOINT.max_1024, IMAGE.width_320],
      [BREAKPOINT.max_1280, IMAGE.width_320],
      [BREAKPOINT.max_1600, IMAGE.width_320],
    ],
  },
  {
    type: RESPONSIVE_TYPE.contentImage,
    values: {
      small: [[BREAKPOINT.max_1600, IMAGE.width_320]],
      medium: [
        [BREAKPOINT.max_1440, IMAGE.width_320],
        [BREAKPOINT.max_1600, IMAGE.width_640],
      ],
      large: [
        // AT BREAKPOINT 320 TAKE IMAGE WITH WIDTH 320
        [BREAKPOINT.max_320, IMAGE.width_320],
        [BREAKPOINT.max_640, IMAGE.width_640],
        [BREAKPOINT.max_768, IMAGE.width_1024],
        [BREAKPOINT.max_1024, IMAGE.width_640],
        [BREAKPOINT.max_1280, IMAGE.width_640],
        [BREAKPOINT.max_1440, IMAGE.width_1024],
        [BREAKPOINT.max_1600, IMAGE.width_640],
      ],
    },
  },
  // ImageGallery images
  {
    type: RESPONSIVE_TYPE.imageGalleryImage,
    values: [
      [BREAKPOINT.max_320, IMAGE.width_320],
      [BREAKPOINT.max_640, IMAGE.width_640],
      [BREAKPOINT.max_768, IMAGE.width_1024],
      [BREAKPOINT.max_1024, IMAGE.width_640],
      [BREAKPOINT.max_1280, IMAGE.width_640],
      [BREAKPOINT.max_1440, IMAGE.width_1024],
      [BREAKPOINT.max_1600, IMAGE.width_640],
    ],
  },
  // ImageGallery image in the slider in a popup
  {
    type: RESPONSIVE_TYPE.imageGalleryImageInPopUp,
    values: [
      [BREAKPOINT.max_320, IMAGE.width_320],
      [BREAKPOINT.max_640, IMAGE.width_640],
      [BREAKPOINT.max_768, IMAGE.width_1024],
      [BREAKPOINT.max_1024, IMAGE.width_1024],
      [BREAKPOINT.max_1280, IMAGE.width_1280],
      [BREAKPOINT.max_1440, IMAGE.width_1600],
      [BREAKPOINT.max_1600, IMAGE.width_1600],
    ],
  },
] as const;
/* eslint-enable camelcase */

export { BREAKPOINT_TO_IMAGE_WIDTH, IMAGE, RESPONSIVE_TYPE };
